(
    function (skyward, $, undefined)
    {
        skyward.massapprovebrowse = skyward.massapprovebrowse || {};

        var toggleApprove = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonApprove' + data.taskinstanceid);
            var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');
                var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');

                updateCustomSaveData(getEditableBrowseData(), data, 'true');
            }
        };

        var toggleDeny = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var element = $(this);
            var data = element.data();
            var button = $('#massApproveButtonDeny' + data.taskinstanceid);
            var svgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
            if (button.hasClass('massApproveBrowseDeniedRecord'))
            {
                removeButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Deny');
                updateCustomSaveData(getEditableBrowseData(), data);
            }
            else
            {
                addButtonClass(button, svgText, 'massApproveBrowseDeniedRecord', 'Denied');
                var approveButton = $('#massApproveButtonApprove' + data.taskinstanceid);
                var approveSvgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                removeButtonClass(approveButton, approveSvgText, 'massApproveBrowseApprovedRecord', 'Approve');

                var approveAllButton = $('#massApproveBrowseApproveAllButton');
                var approveAllSvgText = $('#massApproveBrowseContainerApproveAll .buttonText');
                removeButtonClass(approveAllButton, approveAllSvgText, 'massApproveBrowseApprovedRecord', 'Approve All');
                updateCustomSaveData(getEditableBrowseData(), data, 'false');
            }
        };

        var approveAll = function ()
        {
            skyward.buttonManager.setClickInProgress(true);
            var button = $('#massApproveBrowseApproveAllButton');
            var svgText = $('#massApproveBrowseContainerApproveAll .buttonText');

            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            var browse = skyward.browse.browseList[browseName];
            var browseData = skyward.browse.getRequiredBrowseData(browse, browse.data || domBrowse.data());
            var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/ApproveAll';

            if (button.hasClass('massApproveBrowseApprovedRecord'))
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();
                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve');
                });
                removeButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approve All');

                return $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        complete: function () { skyward.buttonManager.setClickInProgress(false) },
                        success : function(data)
                        {
                            var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                            $.each(data.ApprovedRecords, function ()
                            {
                                //updating to not be selected as approved or denied
                                updateCustomSaveData(editableBrowseData, this, null);
                            });
                        },
                        data: browseData
                    });
            }
            else
            {
                $('.massApproveBrowseRowButtonDiv').each(function ()
                {
                    var element = $(this);
                    var data = element.data();

                    var button = $('#massApproveButtonApprove' + data.taskinstanceid);
                    var svgText = $('#massApproveContainerApprove' + data.taskinstanceid + " .buttonText");
                    addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'Approved');

                    var denyButton = $('#massApproveButtonDeny' + data.taskinstanceid);
                    var denySvgText = $('#massApproveContainerDeny' + data.taskinstanceid + " .buttonText");
                    removeButtonClass(denyButton, denySvgText, 'massApproveBrowseDeniedRecord', 'Deny');
                });
                addButtonClass(button, svgText, 'massApproveBrowseApprovedRecord', 'All Approved');
                return $.ajax(
                {
                    url: url,
                    type: "POST",
                    dataType: "JSON",
                    complete: function () { skyward.buttonManager.setClickInProgress(false) },
                    success: function (data)
                    {
                        var editableBrowseData = domBrowse.data().editablebrowsedata || [];

                        $.each(data.ApprovedRecords, function () {
                            //update to be selected as Approved
                            updateCustomSaveData(editableBrowseData, this, true);
                        });
                    },
                    data: browseData
                });
            }
        };

        var getEditableBrowseData = function()
        {
            var browseName = skyward.browse.getCurrentBrowseName();
            var domBrowse = $('#' + browseName);
            return domBrowse.data().editablebrowsedata || [];
        }

        var updateCustomSaveData = function(editableBrowseData, data, value)
        {
            var currentInput = { saveJson: true, name: 'taskinstance-' + data.taskinstanceid, value: value };
            if (data.hasOwnProperty('approvalobjectid')) // old approval workflows don't use an approvalobjectid
            {
                currentInput.data = { approvalobjectid: data.approvalobjectid };
            }
            skyward.dataobjectviewer.updateCustomSaveData(currentInput, editableBrowseData, true);
        }

        var removeButtonClass = function (button, svgText, classname, text)
        {
            if (button.hasClass(classname))
            {
                button.removeClass(classname);
                svgText.text(text);
                svgText.removeClass(classname + 'Text');
            }
        };

        var addButtonClass = function (button, svgText, classname, text)
        {
            button.addClass(classname);
            svgText.text(text);
            svgText.addClass(classname + 'Text');
        };

        var events =
        {
            'toggleApprove': toggleApprove,
            'toggleDeny': toggleDeny,
            'approveAll': approveAll
        };

        skyward.events.registerEvents('massapprovebrowse', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);